import axios from 'axios'

const api = axios.create({
  baseURL: window[window.macarons].backGRC,
  headers: {
    'X-Auth-Token': ''
  }
})

class Cache {
  constructor () {
    this.api = api
    this.duration = (window[window.macarons].featureCacheDuration || 60 * 5) * 1000
    this.cache = {}
  }

  features (type, location, neighbors) {
    if (typeof type === 'undefined') {
      return Promise.resolve([])
    }

    const key = `${location}@${type}#${neighbors || false}`
    let cached = this.cache[key]

    if (typeof cached === 'undefined') {
      const query = { types: [type] }

      if (typeof location !== 'undefined') {
        if (neighbors) {
          query.boundingBox = {
            type: 'App\\Model\\BoundingBox\\LocationBoundingBox',
            location: location
          }
        } else {
          query.parentLocation = location
        }
      }

      cached = { promise: this.api.post('/geo/features', query).then(({data}) => data) }
    }

    if (this.duration < 0) {
      return cached.promise
    }

    this.cache[key] = cached

    if (this.duration > 0) {
      clearTimeout(cached.timeout)
      cached.timeout = setTimeout(() => {
        delete this.cache[key]
      }, this.duration)
    }

    return cached.promise
  }
}

const cache = new Cache()

export default cache

export {
  api,
  cache
}



// WEBPACK FOOTER //
// ./src/graphs/FeatureCache.js